import Immutable from 'immutable';
import get from 'lodash/get';
import { defaultCommunicationObject, updateCommunicationObject } from '~client/reducers/shared';
import { reconciliationActionTypes } from '~client/constants/actionTypes';

export const defaultState = Immutable.fromJS({
  list: {
    communication: defaultCommunicationObject,
    totalCount: 0,
    payload: [],
  },
});

const reconciliationReducer = (state = defaultState, action) => {
  switch (action.type) {
    case reconciliationActionTypes.GET_RECONCILIATION_LIST_CS:
      return state.mergeDeep({
        list: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case reconciliationActionTypes.SET_RECONCILIATION_LIST: {
      const nextState = state.deleteIn(['list', 'payload']);

      return nextState.mergeDeep({
        list: {
          payload: get(
            action,
            `payload.${
              action.isOrder ? 'listDashboardOrderReceivables' : 'listOpportunityReconciliation'
            }.edges`,
          ),
          totalCount: get(
            action,
            `payload.${
              action.isOrder ? 'listDashboardOrderReceivables' : 'listOpportunityReconciliation'
            }.totalCount`,
          ),
        },
      });
    }

    default:
      return state;
  }
};

export default reconciliationReducer;
